import request from "axios"
import qs from "qs"
/* const instance = request.create({
    baseURL: "http://tulu-app.artron.net",
    timeout: 1000 * 10,
    withCredentials: true
}) */
const instance = request.create({
    //baseURL: "https://api-live.artron.net/",
    baseURL: "https://api-live.artron.net/",
    timeout: 1000 * 60,
    withCredentials: true,
})

instance.interceptors.request.use(
    config => {
        if(config.url.indexOf("http") == -1 || config.url.indexOf("tulu-app") != -1){
            config.headers["IsWap"] = "1"
        }
        if(config.url.indexOf("artronim-push.artron.net") != -1){
            config.headers["Im-Token"] = sessionStorage.getItem('token');//token值
        }
        return config
    },
    error => {
        return Promise.resolve(error)
    }
)


export const get = (url, params) => instance.get(url, { params })
export const post = (url, params) => {
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    // let data = qs.stringify(
                    //     param
                    // );
                    // request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    //request.defaults.headers.post['IsWap'] = 1;
                    /* request.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
                    request.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, DELETE';
                    request.defaults.headers.post['Access-Control-Allow-Headers'] = 'Content-Type'; */
                    instance.post( url,  params)
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
                .then((result) => {
                    if(result.hasOwnProperty("data") && typeof(result)=='object')
                        return Promise.resolve(result.data);
                    else
                        return Promise.reject.data;
                })
                .catch(error=>{
                    // return Promise.reject.data;
                    throw new Error('url>>'+url+error.toString());
                });
        }catch (e) {
            return false;
        }
        // return instance.post(url, params, config)
}
export const put = (url, params) => instance.put(url, qs.stringify(params))
export const del = (url, params) => instance.delete(url, { params })
